import { z } from 'zod';
import { ProviderName } from './connections.js';

/** `GET /api/setup/status` (admin) : avancement de la première configuration. */
export const SetupStep = z.object({
  key: z.string(),
  label: z.string(),
  done: z.boolean(),
  detail: z.string().optional(),
  /** Où faire l'étape dans l'appli (ex. `/reglages/connexions#connexion-axonaut`, `/compte-google`). */
  href: z.string().optional(),
  /** Étape d'avertissement (ex. base qui a servi à la démo) : à régler avant le reste. */
  warning: z.boolean().optional(),
});
export type SetupStep = z.infer<typeof SetupStep>;

export const SetupStatus = z.object({
  steps: z.array(SetupStep),
  done: z.boolean(),
  /** Le plan de démonstration (`demo.sample`) est disponible (FORCE_FAKE seulement). */
  demoPlanAvailable: z.boolean(),
  /** Démonstration (FORCE_FAKE) : toutes les connexions sont simulées. */
  demoMode: z.boolean().optional(),
});
export type SetupStatus = z.infer<typeof SetupStatus>;

/**
 * `GET /api/connections/overview` (tout membre connecté) : quelles connexions sont prêtes, pour les états
 * vides des écrans (« Connecte Axonaut dans Réglages… »). Jamais de secret ni de configuration.
 */
export const ConnectionsOverview = z.object({
  /** Démonstration (FORCE_FAKE) : tout est simulé. */
  demo: z.boolean(),
  connections: z.array(
    z.object({
      provider: ProviderName,
      /** Identifiants présents et dernier test réussi. */
      ready: z.boolean(),
      lastSyncAt: z.string().nullable(),
    }),
  ),
});
export type ConnectionsOverview = z.infer<typeof ConnectionsOverview>;
